import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteUser } from "firebase/auth";
import { auth } from './firebase';
import { useAuth } from './AuthContext';
import { 
  FiAlertTriangle, 
  FiTrash2, 
  FiXCircle, 
  FiArrowLeft 
} from 'react-icons/fi';
import './auth-pages.css';

function DeleteAccountConfirmPage() {
  const [isDeleting, setIsDeleting] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { setNextPageAfterReauth } = useAuth();

  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      await deleteUser(auth.currentUser);
      // We won't show success message since we're redirecting
      navigate('/login');
    } catch (error) {
      setIsDeleting(false);
      setError(error.message);
      
      if (error.code === 'auth/requires-recent-login') {
        // If the error is due to a non-recent login, direct the user to reauthenticate
        setNextPageAfterReauth('/dashboard/delete-account-confirm');
        navigate('/dashboard/reauthenticate');
      }
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Delete Account</h1>
          <p>This action cannot be undone</p>
        </div>

        <div className="auth-warning" style={{ marginBottom: '2rem' }}>
          <FiAlertTriangle size={24} />
          <div>
            <p style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
              Warning: Permanent Account Deletion
            </p>
            <p>
              Deleting your account will permanently remove all your data, including:
            </p>
            <ul style={{ marginLeft: '1.5rem', marginTop: '0.5rem' }}>
              <li>All transcription history</li>
              <li>Account settings and preferences</li>
              <li>Premium subscription status (if applicable)</li>
            </ul>
          </div>
        </div>

        {error && (
          <div className="auth-error">
            <FiXCircle />
            <span>{error}</span>
          </div>
        )}

        <button 
          className="auth-btn danger-btn" 
          onClick={confirmDelete}
          disabled={isDeleting}
        >
          <FiTrash2 /> {isDeleting ? 'Deleting Account...' : 'Confirm Delete'}
        </button>

        <button 
          className="auth-btn secondary-btn" 
          onClick={() => navigate('/dashboard/profile')}
          disabled={isDeleting}
        >
          <FiArrowLeft /> Cancel and Return to Profile
        </button>
      </div>
    </div>
  );
}

export default DeleteAccountConfirmPage;